import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorScreen from '~/components/ErrorScreen/ErrorScreen';
import { startNewApplication } from '~/services/SdkService';
import type { SdkError } from '~/types/interaction';
import { getErrorMessage } from '~/utils/utilities';

const Apply = () => {
  const { referrerId } = useParams();

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  //start the guest flow application journey for the user
  const startApplication = async () => {
    if (!referrerId) {
      setError(getErrorMessage({ message: 'Invalid referrer' } as SdkError));
      return;
    }
    const [ok, result] = await startNewApplication(referrerId);
    if (!ok) {
      setError(getErrorMessage(result as SdkError));
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    startApplication();
  }, [referrerId]);

  return !loading && error ? (
    <ErrorScreen
      message="Resume application to start where you left off and get instant loan"
      title="Complete your application"
      onButtonClick={async () => {
        setError(null);
        setLoading(true);
        await startApplication();
        setLoading(false);
      }}
      ctaText="Resume application"
    />
  ) : (
    <div />
  );
};

export default Apply;
